<template>
    <v-app>
        <!--    <v-app-bar-->
        <!--      app-->
        <!--      color="dark"-->
        <!--      dark-->
        <!--    >-->
        <!--      <div class="d-flex align-center">-->
        <!--        &lt;!&ndash;<v-img&ndash;&gt;-->
        <!--          &lt;!&ndash;alt="Vuetify Logo"&ndash;&gt;-->
        <!--          &lt;!&ndash;class="shrink mr-2"&ndash;&gt;-->
        <!--          &lt;!&ndash;contain&ndash;&gt;-->
        <!--          &lt;!&ndash;src="https://cdn.vuetifyjs.com/images/logos/vuetify-logo-dark.png"&ndash;&gt;-->
        <!--          &lt;!&ndash;transition="scale-transition"&ndash;&gt;-->
        <!--          &lt;!&ndash;width="40"&ndash;&gt;-->
        <!--        &lt;!&ndash;/>&ndash;&gt;-->
        <!--        Mineit Monitor-->
        <!--        &lt;!&ndash;<v-img&ndash;&gt;-->
        <!--          &lt;!&ndash;alt="Vuetify Name"&ndash;&gt;-->
        <!--          &lt;!&ndash;class="shrink mt-1 hidden-sm-and-down"&ndash;&gt;-->
        <!--          &lt;!&ndash;contain&ndash;&gt;-->
        <!--          &lt;!&ndash;min-width="100"&ndash;&gt;-->
        <!--          &lt;!&ndash;src="https://cdn.vuetifyjs.com/images/logos/vuetify-name-dark.png"&ndash;&gt;-->
        <!--          &lt;!&ndash;width="100"&ndash;&gt;-->
        <!--        &lt;!&ndash;/>&ndash;&gt;-->
        <!--      </div>-->
        <!--      <v-spacer></v-spacer>-->

        <!--&lt;!&ndash;      Menu&ndash;&gt;-->
        <!--      &lt;!&ndash;<v-btn&ndash;&gt;-->
        <!--        &lt;!&ndash;href="https://github.com/vuetifyjs/vuetify/releases/latest"&ndash;&gt;-->
        <!--        &lt;!&ndash;target="_blank"&ndash;&gt;-->
        <!--        &lt;!&ndash;text&ndash;&gt;-->
        <!--      &lt;!&ndash;&gt;&ndash;&gt;-->
        <!--        &lt;!&ndash;<span class="mr-2">Latest Release</span>&ndash;&gt;-->
        <!--        &lt;!&ndash;<v-icon>fas fa-external-link-alt</v-icon>&ndash;&gt;-->
        <!--      &lt;!&ndash;</v-btn>&ndash;&gt;-->
        <!--    </v-app-bar>-->

        <v-main>
            <router-view></router-view>
        </v-main>
    </v-app>
</template>

<script>

    export default {
        name: 'App',

        components: {},
        data: () => ({
            //
        }),
        methods: {
            pollData() {
                this.$store.dispatch('computers/load');
                this.polling = setInterval(() => {
                    this.$store.dispatch('computers/load')
                }, 50000)
            }
        },
        beforeDestroy() {
            clearInterval(this.polling)
        },
        created() {
            this.pollData()
        }
    };
</script>
